import { queryState } from "./creator";

export const queriedProducts = queryState.selector;
